export default {
    authentication: {
        basic: {
            keyToBasic: true
        }
    },
    messages: {
        messagesPost: {
            smsCounter: true
        }
    }
}